export default {
  AccountNumber: 'Account number',
  Bank: 'Bank',
  BranchCode: 'Branch code',
  BranchName: 'Branch name',
  HolderName: 'Holder name',
  ShebaNumber: 'Sheba number',
  verifyDate: 'Verify date',
  payDate: 'Pay date',
  paymentGateway: 'Payment gateway',
  referenceNumber: 'Reference number',
  receiptNumber: 'Receipt number',
  paymentVerified: 'Payment verified',
  paid: 'paid',
  unpaid: 'unpaid',
  discountPercent: 'Discount percent',
  maximumDiscountAmount: 'Maximum discount amount',
  giftCreditConvertiblePercent: 'Gift credit convertible percent',
  paymentDetail: 'Payment detail',
  acceptPayment: 'Accept payment',
  areYouSureYouWantToPayBelowItems: 'Are you sure you want to pay below items?',
  configPayment: 'Config payment',
  payTo: 'Pay to {title}',
  originBankAccount: 'Origin bank account',
  settlementAmount: 'Settlement amount',
  trackingNumber: 'Tracking number',
  transferStatus: 'Transfer status'
}
